export default __webpack_public_path__ + "bg-mobile.ce47db.png";